module.exports = __webpack_public_path__ + "static/media/minmap.ccc36f45.png";